import AjaxAlarmSystem from "./ajax-systems.jpg";
import Arlo from "./arlo.png";
import NestCam from "./nest-cam.png";
import NestProtect from "./nest-protect.png";
import Netatmo from "./netatmo.jpg";
import Point from "./point.png";
import Sikkerthjem from "./sikkerthjem.jpg";
import VisonicPowermaster from "./visonic-powermaster.png";
import YoyoCam from "./yoyocam.jpg";
import Dashboard1 from "./dashboard-1.png";
import Dashboard2 from "./dashboard-2.png";
import ConnectHttp from "./connect-http.png";
import MapMarker from "./map-marker.png";
import LicenseActivation from "./license-activation.png";
import fullWhiteLogo from "./full-white-logo.png";
import ajaxHub from "./ajax-hub.png";
import alarmSmsInactiveCardBg from "./alarm-sms-inactive-card-bg.png";
import alarmSmsIntroCardBg from "./alarm-sms-intro-card-bg.png";
import connectInactiveCardBg from "./connect-inactive-card-bg.png";
import alarmCentralInactiveCardBg from "./alarm-central-inactive-card-bg.png";
import mobileMockups from "./mobile-mockups.png";
import authMobileScreenBg from "./auth-mobile-screen-bg.png";
import authScreenBg from "./auth-screen-bg.png";
import dashboardEmptyServiceCardBg from "./dashboard-empty-service-card-bg.png";
import servicesInfoCardBg from "./services-info-card-bg.png";
import completeHomeAlarm from "./complete-home-alarm.png";
import westraSecurity from "./westra-security.png";

const Images = {
  AjaxAlarmSystem,
  Arlo,
  NestCam,
  NestProtect,
  Netatmo,
  Point,
  Sikkerthjem,
  VisonicPowermaster,
  YoyoCam,
  Dashboard1,
  Dashboard2,
  ConnectHttp,
  MapMarker,
  LicenseActivation,
  fullWhiteLogo,
  ajaxHub,
  alarmSmsInactiveCardBg,
  alarmSmsIntroCardBg,
  connectInactiveCardBg,
  alarmCentralInactiveCardBg,
  mobileMockups,
  authScreenBg,
  authMobileScreenBg,
  dashboardEmptyServiceCardBg,
  servicesInfoCardBg,
  completeHomeAlarm,
  westraSecurity,
};

export default Images;
